<template>
  <div>
    <page-nav-bar
      v-if="t"
      :is-sticky="true"
      :back-button="true"
      :has-actions="true"
      title="FICHE TIERS"
      :subtitle="t.name">
      <template slot="breadcrumb">
        <h1 class="page-header-breadcrumb-item is-uppercase">
          <router-link :to="{ name: 'TiersList'}">
            Tiers
          </router-link>
        </h1>
        <div class="page-header-breadcrumb-separator" />
        <div
          v-if="t.name"
          class="page-header-breadcrumb-item">
          <span class="has-text-weight-normal has-text-grey-dark"><span class="is-uppercase">{{ t.name }}</span></span>
        </div>
      </template>
      <router-link
        id="tiersEditButton"
        slot="dropdown-content"
        :to="{name: 'TiersEdit', params: {id: t.pk}}"
        class="dropdown-item">
        <span class="icon is-medium"><i class="fas fa-user-edit" /></span><span class="is-margin-left-xsmall">Modifier fiche</span>
      </router-link>
      <a
        id="tiersAddInterlocuteurButton"
        slot="dropdown-content"
        class="dropdown-item"
        @click="openInterlocuteurPanel()">
        <span class="icon is-medium"><i class="fas fa-user-plus" /></span><span class="is-margin-left-xsmall">Ajouter un interlocuteur</span>
      </a>
      <a
        slot="dropdown-content"
        class="dropdown-item"
        @click="patchTiers(t, { favorite: !t.favorite })">
        <span class="icon is-medium"><i :class="t.favorite ? 'fas fa-star' : 'fal fa-star'" /></span><span class="is-margin-left-xsmall">{{ t.favorite ? 'Retirer des favoris' : 'Ajouter aux favoris' }}</span>
      </a>
      <a
        id="tiersDeleteButton"
        slot="dropdown-content"
        class="dropdown-item has-background-danger has-text-white"
        @click="deleteTiers(t)">
        <span class="icon is-medium"><i class="fas fa-trash-alt" /></span><span class="is-margin-left-xsmall">Supprimer tiers</span>
      </a>
    </page-nav-bar>
    <spinner-round
      v-if="loading"
      :is-loading="loading" />
    <page-content
      v-else-if="t && !loading"
      :has-no-padd-on-act-on-desktop="true"
      :has-padd-left-on-act="true"
      :has-padd-right-on-act="true"
      :has-left-col-small="true"
      :has-left-col-small-size-fixed="false"
      :has-sticky-col-left="true">
      <template slot="left-col-small">
        <div class="has-background-white is-border">
          <div class="is-padding-top is-padding-left is-padding-right is-padding-bottom-small has-text-centered">
            <avatar
              :item="t"
              class="is-medium" />
            <div class="title is-3 is-margin-top-xsmall is-marginless-bottom">
              <b id="tiersName">{{ t.name }}</b>
              <div class="is-padding-top-xxsmall is-size-5 has-text-weight-light">
                <span class="tag is-light is-border">{{ tiersTypeLabel(t.type) }}</span>
                <span
                  v-if="t.favorite"
                  class="icon has-text-warning is-margin-left-xxsmall"><i class="fas fa-star"></i></span>
              </div>
            </div>
          </div>
          <div class="is-padding is-border-top">
            <div class="columns is-multiline">
              <div class="column is-12 is-paddingless-bottom">
                <div class="columns is-gapless">
                  <div class="column is-size-6 is-narrow is-w80p is-margin-right-xsmall">
                    <b>Adresse :</b>
                  </div>
                  <div
                    v-if="t.address && (t.address.line1 || t.address.city)"
                    class="column is-size-6">
                    {{ t.address.line1 }}<span v-if="t.address.line1">,</span><br v-if="t.address.line1">
                    {{ t.address.zip_code }} {{ t.address.city }}
                  </div>
                  <div v-else>
                    NC
                  </div>
                </div>
              </div>
              <div class="column is-12 is-paddingless-bottom">
                <div class="columns is-gapless">
                  <div class="column is-size-6 is-narrow is-w80p is-margin-right-xsmall">
                    <b>Mail :</b>
                  </div>
                  <div class="column is-size-6 is-break-word">
                    <a
                      v-if="t.email"
                      :href="`mailto:${t.email}`"
                      class="is-hover-underline">{{ t.email }}</a>
                    <span v-else>NC</span>
                  </div>
                </div>
              </div>
              <div class="column is-12 is-paddingless-bottom">
                <div class="columns is-gapless">
                  <div class="column is-size-6 is-narrow is-w80p is-margin-right-xsmall">
                    <b>Téléphone :</b>
                  </div>
                  <div class="column is-size-6">
                    <phone-number
                      v-if="t.phone"
                      :phone="t.phone" />
                    <span v-else>NC</span>
                  </div>
                </div>
              </div>
              <div class="column is-12">
                <div class="columns is-gapless">
                  <div class="column is-size-6 is-narrow is-w80p is-margin-right-xsmall">
                    <b>Site web :</b>
                  </div>
                  <div class="column is-size-6 is-break-word">
                    <a
                      v-if="t.website"
                      :href="t.website"
                      target="_blank"
                      class="is-hover-underline">{{ t.website }}</a>
                    <span v-else>NC</span>
                  </div>
                </div>
              </div>
              <div class="column is-12">
                <router-link
                  class="is-linkTextPicto is-size-6"
                  :to="{name: 'TiersEdit', params: {id: t.pk}}">
                  <span><i>Modifier fiche tiers</i></span>
                  <span class="icon"><i class="fal fa-long-arrow-right" /></span>
                </router-link>
              </div>
            </div>
          </div>
          <div class="columns is-multiline is-gapless is-border-top is-marginless">
            <div class="column is-12 columns is-column is-padding">
              <div class="is-size-6">
                <b>Utilisations : </b>
                <span>{{ t.usages ? t.usages.length : (t.usage_count || 0) }}</span>
              </div>
            </div>
          </div>
          <div class="columns is-multiline is-gapless is-border-top is-marginless">
            <div class="column is-12 columns is-column is-padding">
              <div class="is-size-6">
                <b>Créé le : </b>
                <span>{{ t.created_on | date }}</span>
                <span class="has-text-grey"> — modifié le {{ t.last_change_date | date }}</span>
              </div>
            </div>
          </div>
          <div
            v-if="t.comment"
            class="columns is-multiline is-gapless is-border-top is-marginless">
            <div class="column is-12 columns is-column is-padding">
              <div class="is-size-6">
                <b>Commentaire : </b>
                <div
                  class="content"
                  v-html="t.comment"></div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <div class="is-border-top">
        <tabs
          :links="tiersTabLinks"
          :level="1"
          class="is-border-left is-border-right is-border-bottom" />
        <router-view
          :key="$route.name"
          :source-tiers="t"
          class="has-background-white is-border-left is-border-right is-border-bottom"
          @reloadTiers="getTiers" />
      </div>
    </page-content>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import TiersMixin from './TiersMixin'
import { TIERS_RESOURCE } from './tiersConstants'

export default {
  name: 'TiersVue',
  mixins: [TiersMixin],
  data () {
    return {
      isParent: true
    }
  },
  computed: {
    ...mapState(['quickview'])
  },
  watch: {
    quickview ({ mode, params, results }) {
      if (results && mode === 'INTERLOCUTEUR_FORM' && params && params.origin === 'TiersVue') {
        this.addInterlocuteurToFiche(results.interlocuteur)
      }
    }
  },
  created () {
    if (!this.tiersTabLinks.map(x => x.link).includes(this.tiersView)) {
      this.$router.replace({ name: 'TiersInterlocuteurs' }).catch(() => {})
    }
  },
  methods: {
    openInterlocuteurPanel () {
      this.$store.commit('setQuickview', {
        mode: 'INTERLOCUTEUR_FORM',
        params: {
          source: {},
          origin: 'TiersVue'
        }
      })
    },
    /**
     * @param {object} interlocuteur
     */
    async addInterlocuteurToFiche (interlocuteur) {
      const interlocuteurs = [...(this.t.interlocuteurs || []), interlocuteur]
      try {
        await this.$api.patch(TIERS_RESOURCE, this.t.pk, { interlocuteurs })
        this.$toasted.global.success('Interlocuteur enregistré')
        this.$store.commit('setQuickview', { mode: null, params: null, results: null, close: true })
        this.getTiers(this.t.pk)
      } catch (e) {
        this.$toasted.global.danger('Erreur lors de l\'enregistrement !')
      }
    }
  }
}
</script>
